import { useLazyQuery } from '@apollo/client'
import { GroupName, GroupNameVariables } from '../../types'
import { GROUP_NAME } from './operations'

export const useGroupName = () => useLazyQuery<GroupName, GroupNameVariables>(GROUP_NAME)
